module.exports = __webpack_public_path__ + "static/media/card-4.c26bb429.jpf";